import { roundDecimals as p } from "@project-rouge/rg-core";
import { Line as u, Billboard as C, Text as g } from "@react-three/drei";
import { memo as x, useState as F, useCallback as S } from "react";
import { ScreenSizer as T } from "../../3d/screen-sizer/index.js";
import { useRefPersistent as b } from "../../hooks/index7.js";
import { DotFC as j } from "../dot-fc/index.js";
import { PlaneFC as k } from "../plane-fc/index.js";
import { jsxs as i, Fragment as s, jsx as r } from "react/jsx-runtime";
const v = x(function({
  onClear: a,
  radius: c = 10,
  color: l = "#fff000",
  textColor: D = "#757575",
  ...t
}) {
  const d = b(a), [e, f] = F([]), h = S((o) => {
    f((n) => {
      if (n.length === 2) {
        const m = d();
        return m && m(), [];
      }
      return [...n, o];
    });
  }, []);
  return /* @__PURE__ */ i(s, {
    children: [/* @__PURE__ */ r(k, {
      ...t,
      onClick: h
    }), e.map((o, n) => /* @__PURE__ */ r(j, {
      position: o,
      radius: c,
      color: l
    }, n)), e.length === 2 && /* @__PURE__ */ i(s, {
      children: [/* @__PURE__ */ r(u, {
        ...t,
        points: e,
        color: l
      }), /* @__PURE__ */ r(C, {
        position: e[0].clone().add(e[1]).multiplyScalar(0.5),
        children: /* @__PURE__ */ r(T, {
          children: /* @__PURE__ */ i(g, {
            fontSize: 17,
            color: "#000",
            position: [0, 15, 0],
            renderOrder: t.renderOrder,
            "material-depthTest": t.depthTest,
            "material-depthWrite": t.depthWrite,
            children: [p(e[0].distanceTo(e[1])), " m"]
          })
        })
      })]
    })]
  });
});
export {
  v as MeasureFC
};
//# sourceMappingURL=index.js.map
